export class SourceOfApp {
  SACode;
  CDesc;
  EDesc;
  SpecReq;
  constructor() {
    this.SACode = "";
    this.CDesc = "";
    this.EDesc = "";
    this.SpecReq = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/SourceOfApp.js